import ErrorMessageontextWrapper from './components/root/error-message-context-wrapper';
import { RootComponent } from './components/root/root';
import ThemeContextWrapper from './components/root/theme-context-wrapper';
import StylesContextWrapper from './contexts/styles-context/styles-context-wrapper';
import { quizHistoryService } from './services/history.service';

export function App(props) {

  return (
    <ErrorMessageontextWrapper>
      <ThemeContextWrapper>
        <StylesContextWrapper>
          <RootComponent
            {...props}
            historyService={quizHistoryService}
          />
        </StylesContextWrapper>
      </ThemeContextWrapper>
    </ErrorMessageontextWrapper>
  )
};